module.exports = __webpack_public_path__ + "assets/img/njl_icon.2e4f171a.png";